const NewVote = () => import(/* webpackChunkName: 'activity' */ './newVote');
const VoteIndex = () => import(/* webpackChunkName: 'activity' */ './voteIndex');
const VoteList = () => import(/* webpackChunkName: 'activity' */ './voteList');
const SignIndex = () => import(/* webpackChunkName: 'activity' */ './signIndex');
const SignList = () => import(/* webpackChunkName: 'activity' */ './signList');
const NewSign = () => import(/* webpackChunkName: 'activity' */ './newSign');


const routes = [
  { path: '/activity/newVote', component: NewVote },
  { path: '/activity/voteIndex', component: VoteIndex },
  { path: '/activity/voteList', component: VoteList },
  { path: '/activity/signIndex', component: SignIndex },
  { path: '/activity/signList', component: SignList },
  { path: '/activity/newSign', component: NewSign },
];

export default routes;
